import { getResourceFromCms } from '@namespace/helpers';

export const getSiteSettings = (options) =>
  getResourceFromCms('/siteSettings', options);
